import commonService from "./common-service";

class MARDrugService {
  async getMARDrugs() {
    try {
      const response = await commonService.getFromServer("EOM/MAR", {});
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async createMARDrug(params) {
    try {
      let response = await commonService.postToServer("EOM/MAR", params);
      if (response) {
        return response;
      } else {
        throw new Error("Error");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async updateMARDrug(params) {
    try {
      let response = await commonService.updateToServer(
        "EOM/MAR/" + params.id,
        params
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }
  async getMARDrug(id) {
    try {
      const response = await commonService.getFromServer("EOM/MAR/" + id, {});
      if (response) {
        return response;
      } else {
        throw new Error("Error loading carriers");
      }
    } catch (e) {
      throw new Error(e.msg.error);
    }
  }

  async deleteMARDrug(id) {
    try {
      const response = await commonService.deleteToServer("EOM/MAR/" + id, {});

      if (response) {
        return response;
      } else {
        throw new Error("Error deleting profile");
      }
    } catch (e) {
      throw new Error("Error deleting profile");
    }
  }
  async uploadDocument(params) {
    try {
      const response = await commonService.postToServer(
        "EOM/MAR/Upload",
        params
      );
      if (response) {
        return response;
      } else {
        throw new Error("Error uploading document");
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  async downloadDocument(params) {
    try {
      await commonService.downloadFromServer("EOM/MAR/Download", {
        fileName: "MAR.xlsx",
      });
    } catch (e) {
      throw new Error(e.message);
    }
  }
}

export default new MARDrugService();
